import { Record } from "appworks/model/gameplay/records/record";
import { Result } from "appworks/model/gameplay/records/results/result";
import { ResultBuilder } from "appworks/server/builders/result-builder";
import { convertGamevyPatternToLine, getSymbolDefinitionFromServerID } from "gamevy/integration/gamevy-utils";
import { LineResult } from "slotworks/model/gameplay/records/results/line-result";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";
import { GamevyWinSchema } from "../../schema/gamevy-spin-response-schema";

export class LineResultsBuilder implements ResultBuilder {

    public filter(response: GamevyWinSchema): boolean {
        return response.type === "line";
    }

    public build(record: Record, response: GamevyWinSchema): Result[] {

        const symbolDefinition = getSymbolDefinitionFromServerID(response.symbol);

        const result = new LineResult();
        result.symbolType = symbolDefinition.id;
        result.cashWon = response.amount.CASH || 0;
        result.line = response.line;
        result.positions = convertGamevyPatternToLine(response.pattern);
        result.matches = response.length;

        result.symbols = result.positions.map((position) => {
            return (record as SpinRecord).grid[position.x][position.y];
        });

        return [result];
    }
}

export const lineResultsBuilder = new LineResultsBuilder();
